import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterItemBindingStatusValue,
  UniversalFilterItemBindingStatusModes,
  UniversalFilterItemBindingStatusFilterState,
  UniversalFilterItemBindingStatusOnChange
} from '../../UniversalFilterItemBindingStatus.types';

interface UniversalFilterItemBindingStatusFilterStateOptions {
  onChange: UniversalFilterItemBindingStatusOnChange;
}

function useUniversalFilterItemBindingStatusFilterState({
  onChange
}: UniversalFilterItemBindingStatusFilterStateOptions) {
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterItemBindingStatusFilterState) => void
  >(
    (filterState) => {
      const bindingStatus = filterState?.bindingStatus;

      if (
        filterState?.mode ===
        UniversalFilterItemBindingStatusModes.CONTAINS_ALL_OF
      ) {
        onChange(isEmpty(bindingStatus) ? undefined : { in: bindingStatus });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterItemBindingStatusValue
    ) => UniversalFilterItemBindingStatusFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue?.in)) {
      return {
        mode: UniversalFilterItemBindingStatusModes.CONTAINS_ALL_OF,
        userIds: filterValue.in
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterItemBindingStatusFilterState;
